/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Icd10Code } from './Icd10Code';
import {
    Icd10CodeFromJSON,
    Icd10CodeFromJSONTyped,
    Icd10CodeToJSON,
    Icd10CodeToJSONTyped,
} from './Icd10Code';

/**
 * 
 * @export
 * @interface PccPatientCondition
 */
export interface PccPatientCondition {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    is_therapy?: boolean;
    /**
     * 
     */
    clinical_status: PccPatientConditionClinicalStatusEnum;
    /**
     * 
     */
    onset_date: string;
    /**
     * 
     */
    resolved_date?: string;
    /**
     * 
     */
    rank: PccPatientConditionRankEnum;
    /**
     * 
     */
    additional_information?: string;
    /**
     * 
     */
    icd_10_code_id?: string;
    /**
     * 
     */
    icd_10_code?: Icd10Code;
    /**
     * 
     */
    pcc_historical_condition_id?: string;
    /**
     * 
     */
    found_by_description?: boolean;
}


/**
 * @export
 */
export const PccPatientConditionClinicalStatusEnum = {
    Active: 'Active',
    Resolved: 'Resolved',
} as const;
export type PccPatientConditionClinicalStatusEnum = typeof PccPatientConditionClinicalStatusEnum[keyof typeof PccPatientConditionClinicalStatusEnum];

/**
 * @export
 */
export const PccPatientConditionRankEnum = {
    Primary: 'Primary',
    Secondary: 'Secondary',
} as const;
export type PccPatientConditionRankEnum = typeof PccPatientConditionRankEnum[keyof typeof PccPatientConditionRankEnum];


/**
 * Check if a given object implements the PccPatientCondition interface.
 */
export function instanceOfPccPatientCondition(value: object): value is PccPatientCondition {
    if (!('clinical_status' in value) || value['clinical_status'] === undefined) return false;
    if (!('onset_date' in value) || value['onset_date'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    return true;
}

export function PccPatientConditionFromJSON(json: any): PccPatientCondition {
    return PccPatientConditionFromJSONTyped(json, false);
}

export function PccPatientConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'is_therapy': json['is_therapy'] == null ? undefined : json['is_therapy'],
        'clinical_status': json['clinical_status'],
        'onset_date': json['onset_date'],
        'resolved_date': json['resolved_date'] == null ? undefined : json['resolved_date'],
        'rank': json['rank'],
        'additional_information': json['additional_information'] == null ? undefined : json['additional_information'],
        'icd_10_code_id': json['icd_10_code_id'] == null ? undefined : json['icd_10_code_id'],
        'icd_10_code': json['icd_10_code'] == null ? undefined : Icd10CodeFromJSON(json['icd_10_code']),
        'pcc_historical_condition_id': json['pcc_historical_condition_id'] == null ? undefined : json['pcc_historical_condition_id'],
        'found_by_description': json['found_by_description'] == null ? undefined : json['found_by_description'],
    };
}

export function PccPatientConditionToJSON(json: any): PccPatientCondition {
    return PccPatientConditionToJSONTyped(json, false);
}

export function PccPatientConditionToJSONTyped(value?: PccPatientCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'is_therapy': value['is_therapy'],
        'clinical_status': value['clinical_status'],
        'onset_date': value['onset_date'],
        'resolved_date': value['resolved_date'],
        'rank': value['rank'],
        'additional_information': value['additional_information'],
        'icd_10_code_id': value['icd_10_code_id'],
        'icd_10_code': Icd10CodeToJSON(value['icd_10_code']),
        'pcc_historical_condition_id': value['pcc_historical_condition_id'],
        'found_by_description': value['found_by_description'],
    };
}

